// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { SearchResultVO } from './search-result.vo';
import { SuitableConnectionsSetVO } from './suitable-connections-set.vo';
import { ArticleWithTechnicalPropertiesDTO } from '@article/properties/technical/technical-requirements';

@JsonObject('ArticleInfoConnectionSetVO')
export class ArticleInfoConnectionSetVO {

  @JsonProperty('articleWithTechnicalProperties', 'ArticleWithTechnicalPropertiesConverter', true)
  public articleWithTechnicalProperties: ArticleWithTechnicalPropertiesDTO = undefined;
  @JsonProperty('connectionSets', '[SuitableConnectionsSetVO]')
  public connectionSets: SuitableConnectionsSetVO[] = undefined;
  @JsonProperty('isExcludedFromPrintLabeling', 'Boolean')
  public isExcludedFromPrintLabeling: boolean = undefined;
}

@JsonObject('AccessorySearchResultVO')
export class AccessorySearchResultVO extends SearchResultVO {

  public static readonly CLASS_NAME: string = 'AccessorySearchResultVO';

  @JsonProperty('articleInfoConnectionSet', '[ArticleInfoConnectionSetVO]')
  public articleInfoConnectionSet: ArticleInfoConnectionSetVO[] = undefined;
  @JsonProperty('count', 'Number')
  public count: number = undefined;
  @JsonProperty('queryElectedArticleIdsIncludedInCompleteSearchResult', '[Number]')
  public queryElectedArticleIdsIncludedInCompleteSearchResult: number[] = undefined;

  public constructor() {
    super();
    this.type = AccessorySearchResultVO.CLASS_NAME;
  }
}
